import React from 'react';
import './Container.css'
import { view } from 'react-easy-state';

export default view((props) => (
  <div className={
    "container cf " + 
    (props.vscrolled ? 'container-vscrolled ' : '') + 
    (props.vfull ? 'container-vfull ' : '') + 
    (props.relative ? 'relative ' : '') + 
    (props.margins ? 'margins ' : '') + 
    (props.panel ? 'panel ' : '') + 
    (props.fill ? 'fill ' : '') + 
    (props.halfSpace ? 'halfSpace ' : '') + 
    (props.className ? props.className : '')
  }>{props.children}</div>
))